var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpenSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.142,
    height: 18,
    viewBox: "0 0 23.142 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.786,32c-2.2.125-6.578.58-9.28,2.234a.618.618,0,0,0-.292.529V49.38a.636.636,0,0,0,.935.542c2.78-1.4,6.8-1.781,8.787-1.885a1.253,1.253,0,0,0,1.206-1.232V33.231A1.26,1.26,0,0,0,21.786,32ZM10.636,34.231C7.935,32.578,3.559,32.123,1.357,32A1.26,1.26,0,0,0,0,33.231V46.806a1.253,1.253,0,0,0,1.206,1.232c1.988.1,6.01.487,8.79,1.886a.634.634,0,0,0,.933-.541V34.753A.6.6,0,0,0,10.636,34.231Z",
    transform: "translate(0 -31.996)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpenSolid);
export default __webpack_public_path__ + "static/media/book-open-solid.83154b01afe4f118b412419d0675210e.svg";
export { ForwardRef as ReactComponent };